<template>
  <div>
    <div class="text-link-lists">
      <TextLinkList href="/" text="テキストリンクリスト" :border="true" />
      <TextLinkList href="/" text="テキストリンクリスト" :border="true" />
    </div>
    <div class="text-link-lists">
      <TextLinkList href="/" text="テキストリンクリスト（下線無し）" />
      <TextLinkList href="/" text="テキストリンクリスト（下線無し）" />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（記号なし）"
        :has-chevron="false"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（ボールド）"
        :bold="true"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（記号がリンク色）"
        chevron-color="link"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（背景色がgray-3）"
        background-color="gray-3"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（height:48px）"
        :thin="true"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（サイドメニュー用組み合わせサンプル1）"
        :bold="true"
        chevron-color="link"
      />
    </div>
    <div class="text-link-lists">
      <TextLinkList
        href="/"
        text="テキストリンクリスト（サイドメニュー用組み合わせサンプル2）"
        :bold="true"
        :thin="true"
        chevron-color="link"
        background-color="gray-3"
      />
    </div>
  </div>
</template>
<script>
import TextLinkList from '../../components/molecules/text_link_lists/TextLinkList.vue'
export default {
  components: { TextLinkList }
}
</script>
